import mList from '_v/common/m-list'
import RoomAdvSearch from './room-adv-search'
import SelectTags from '_vc/select-tags'

// 合同列表
export default {
    mixins: [mList],
    components: {
        RoomAdvSearch,
        SelectTags,
    },
    data() {
        return {}
    },
    computed: {
        // 综合排序
        orderBysList() {
            var list = []
            if (this.channelType == 2) {
                // 出房 1
                list.push(
                    {
                        id: 'publishStatus desc,houseName asc',
                        text: '综合排序',
                    },
                    { id: 'rent desc', text: '租金由大到小' },
                    { id: 'rent asc', text: '租金由小到大' }
                )
            } else if (this.channelType == 1) {
                // 找房 2
                list.push(
                    {
                        id: 'publishStatus desc,houseName asc',
                        text: '综合排序',
                    },
                    { id: 'rent desc', text: '租金由大到小' },
                    { id: 'rent asc', text: '租金由小到大' },
                    { id: 'commission desc', text: '佣金由大到小' },
                    { id: 'commission asc', text: '佣金由小到大' }
                )
            }

            return list
        },
    },
    created() {
        if (!this.filter.orderBys) {
            this.filter.orderBys = this.orderBysList[0].id
        }
    },
    methods: {
        // 关闭搜索条件
        onAdvItemClose(item, index) {
            var key = item.key

            // daterange
            if (key.indexOf('-') >= 0) {
                var [k1, k2] = key.split('-')

                this.advFilter[k1] = ''
                this.advFilter[k2] = ''
            }
            // selection
            else if (typeof this.advFilter[key] === 'object') {
                this.advFilter[key].splice(index, 1)
            }
            // others
            else {
                this.advFilter[key] = ''
            }

            this.$nextTick(() => this.search())
        },
        // 高级搜索点确定
        onAdvConfirm(val, options) {
            this.advOptions = options
            this.$nextTick(() => this.search())
        },
        // 标准化筛选数据结构
        normalizeAdvFilter(advFilter) {
            var filter = Object.assign({}, advFilter)

            Object.keys(filter).forEach((k) => {
                switch (k) {
                    default:
                        filter[k] = filter[k].join(',')
                        break
                }
            })

            return filter
        },
    },
}
